export default {
  validation: {
    required: 'Required.',
    // kana_format: "",
    email_format: 'Type in @.lower:validation.variables.email',
    date_format: 'Please enter a valid date. @.lower:validation.variables.date',
    date_range: 'Please enter a date within {intervalYears} years before or after the current date.',
    number_format: 'Type in @.lower:validation.variables.number',
    halfwidth_number_format: 'Only type half-width digit.',
    alphanumeric_format: 'Type in @.lower:validation.variables.alphanumeric',
    company_name_format: 'The company name contains characters that cannot be used.',
    postal_number_no_hyphen: 'Type @:validation.variables.postal_number in no hyphen',
    postal_number_format: '@:validation.variables.postal_number is not correct',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: 'Type in 6 characters or more',
    min_length: 'Type in {length} characters or more',
    max_length: 'Type in {length} characters or less',
    greater_than_or_equal_number: 'Please enter a number greater than or equal to {item}',
    greater_than_number: 'Please enter a number greater than {item}',
    less_than_or_equal_number: 'Please enter a number less than or equal to {item}',
    less_than_number: 'Please enter a number less than {item}',
    max_digit: 'Please enter up to {digit} digits.',
    max_digit_with_item: 'Please enter {item} within {digit} digits',
    number_only: 'Please input only numbers.',
    // decimal_max_digit: "",
    no_blank_or_newline: 'Spaces and line breaks only are not allowed.',
    invalid_zero_number: 'Please enter a non-zero number',
    outlier_ratio: 'This differs significantly from past responses.',
    variables: {
      id_or_email: 'ID/email address',
      email: 'Email address',
      password: 'Password',
      kana: '',
      date: '(e.g. 31/01/2023)',
      number: 'Number',
      alphanumeric: 'Alphabet and numbers',
      postal_number: 'Post code',
    },
    not_same_sharing_email: 'You cannot register an email address that is already shared.',
    not_duplicate_email: 'Duplicate email addresses are not allowed.',
    no_base_locale: 'No base language entry.',
  },
};